import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Trophy,
  BookOpen,
  Settings,
  Ticket,
  AlertCircle,
  Target,
} from "lucide-react";
import PageLayout from "../components/PageLayout";
import MenuButton from "../components/MenuButton";
import { useLang } from "../context/LangContext";
import { userAnswersAPI } from "../api";

const TestsPage: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useLang();
  const [mistakesCount, setMistakesCount] = useState(0);

  useEffect(() => {
    userAnswersAPI
      .getCount()
      .then((res) => setMistakesCount(Number(res.data?.count || 0)))
      .catch(() => {});
  }, []);

  const items = [
    {
      icon: Trophy,
      title: t("realExam"),
      subtitle: t("realExamSub"),
      path: "/quiz/exam",
      badge: "TOP",
    },
    {
      icon: Target,
      title: t("controlExam"),
      subtitle: t("nazoratSub"),
      path: "/quiz/nazorat",
    },
    {
      icon: BookOpen,
      title: t("testsByTopics"),
      subtitle: t("topicsSub"),
      path: "/topics",
    },
    {
      icon: Settings,
      title: t("customTests"),
      subtitle: t("customSub"),
      path: "/custom",
    },
    {
      icon: Ticket,
      title: t("tickets"),
      subtitle: t("ticketsSub"),
      path: "/tickets",
    },
    {
      icon: AlertCircle,
      title: t("myWrongQuestions"),
      subtitle: t("mistakesSub"),
      path: "/quiz/mistakes",
      badge: mistakesCount > 0 ? String(mistakesCount) : undefined,
    },
  ];

  return (
    <PageLayout title={t("catTests")} subtitle={t("testsSubtitle")}>
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        {items.map((item) => (
          <MenuButton
            key={item.path}
            icon={item.icon}
            title={item.title}
            subtitle={item.subtitle}
            badge={item.badge}
            onClick={() => navigate(item.path)}
          />
        ))}
      </div>
    </PageLayout>
  );
};

export default TestsPage;
